export default __webpack_public_path__ + "static/media/Comp 2_00025.988442d7.png";